import React, { Component } from 'react';
export default class Porfolio extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="portfolio">
      <div className="align-center row">
        {
          resumeData.portfolio && resumeData.portfolio.map((section)=>{
            return (
              <div className="collapsed">
                <h1>{section.title}</h1>
                <div id="portfolio-wrapper" className={`bgrid-${section.bgrid} s-bgrid-thirds cf`}>
                {
                  section.items && section.items.map((item)=>{
                    return(
                      <div className={`columns ${section.style} portfolio-item`}>
                        <div className="item-wrap">
                          <a href={`${item.url}`} target="_blank">
                            <img src={`${item.imgurl}`} className="item-img" alt={item.name}/>
                            <div className="overlay">
                              <div className="portfolio-item-meta">
                                <h5>{item.name}</h5>
                                <p>{item.description}</p>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    )
                  })
                }
                </div>
              </div>
            )
          })
        }
      </div>
  </section>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/portfolio/portfolio.js